import { memo } from 'react';
import CaseModuleModalRoot from '@/features/cases/_shared/components/case-modal-root';
import ChannelModalRoot from '@/features/channels/_shared/components/channel-modal-root';
import CustomerModuleModalRoot from '@/features/customers/_shared/components/customer-modal-root/customer-modal-root';
import NotificationModalRoot from '@/features/notifications/components/modals/notification-modal-root';
// import { TicketingModalRoot } from '@/features/ticketings/_shared/components/ticketing-modal-root';
import UserModalRoot from '@/features/users/_shared/components/user-modal-root';
import TicketingModalRootRefactor from '@/features/ticketings/_shared/components/ticketing-modal-root/ticketing-modal-root';
import { AuthModalRoot } from '@/features/auths/_refactor/components/modals/auth-modal-root';

interface IModalRootProviderProps {
  children: React.ReactNode;
}

const ModalRootProvider = memo(({ children }: IModalRootProviderProps) => {
  return (
    <>
      {children}
      <AuthModalRoot />
      <CaseModuleModalRoot />
      <CustomerModuleModalRoot />
      <UserModalRoot />
      {/* <TicketingModalRoot /> */}
      <ChannelModalRoot />
      <NotificationModalRoot />
      <TicketingModalRootRefactor />
    </>
  );
});

ModalRootProvider.displayName = 'ModalRootProvider';

export default ModalRootProvider;
